export default __webpack_public_path__ + "static/media/8.76e91cc4.JPG";